export default __webpack_public_path__ + "static/media/pixel-hero-front.8ad0a9d3.gif";